export const ID_ADMINISTRATION_STONE = 6;

export const TPAG_CARTAO_CREDIT = '03';

export const TPAG_CARTAO_DEBIT = '04';

export const TPAG_PIX = '17';

export const NAME_ADMINISTRATION_STONE = 'Stone';

export const TPAG_CARTAO_VALE_ALIMENTACAO = '10';

export const TPAG_CARTAO_VALE_REFEICAO = '11';

export const TPAG_CARTAO_VALE_PRESENTE = '12';

export const TPAG_CARTAO_VALE_COMBUSTIVEL = '13';

export const TPAG_VOUCHERS = [
  TPAG_CARTAO_VALE_ALIMENTACAO,
  TPAG_CARTAO_VALE_REFEICAO,
  TPAG_CARTAO_VALE_PRESENTE,
  TPAG_CARTAO_VALE_COMBUSTIVEL,
];
